import { line, curveMonotoneX, area } from 'd3-shape';
import { scalePoint, scaleLinear, scaleBand, scaleSqrt } from 'd3-scale';
import { axisBottom, axisLeft, axisRight } from 'd3-axis';
import { timeParse, timeFormat } from 'd3-time-format';
import { timeDays } from 'd3-time';
import { select } from 'd3-selection';
import { extent, max, min } from 'd3-array';
import { format } from 'd3-format';

export default {
  line,
  area,
  curveMonotoneX,
  scalePoint,
  scaleLinear,
  scaleBand,
  scaleSqrt,
  axisBottom,
  axisLeft,
  axisRight,
  timeParse,
  timeFormat,
  timeDays,
  select,
  extent,
  min,
  max,
  format,
};

// use
// import d3 from './d3Importer.js';
